import { render, staticRenderFns } from "./GeralCandidatoComponent.vue?vue&type=template&id=be1a665e&scoped=true&"
import script from "./GeralCandidatoComponent.vue?vue&type=script&lang=js&"
export * from "./GeralCandidatoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1a665e",
  null
  
)

export default component.exports